/**
 * InfinitSales - Reply Ruler Service
 * Régua de resposta: follow-up automático por inatividade, por funil/etapa.
 */
import api from './api';

const BASE = '/api/reply-rulers/';

class ReplyRulerService {
  async list() {
    const response = await api.get(BASE);
    return response.data;
  }

  async create(data) {
    const response = await api.post(BASE, data);
    return response.data;
  }

  async update(rulerId, data) {
    const response = await api.put(`${BASE}${rulerId}`, data);
    return response.data;
  }

  async remove(rulerId) {
    const response = await api.delete(`${BASE}${rulerId}`);
    return response.data;
  }

  async history(rulerId, limit = 100) {
    const response = await api.get(`${BASE}${rulerId}/history`, { params: { limit } });
    return response.data;
  }

  async enrollments(rulerId, limit = 100) {
    const response = await api.get(`${BASE}${rulerId}/enrollments`, { params: { limit } });
    return response.data;
  }
}

const replyRulerService = new ReplyRulerService();
export default replyRulerService;
